import { IconSvgProps } from "@/libraries/wpl/foundations/src/icons/types";

export const CommentIcon = ({ size }: IconSvgProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 48 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Brand Icons/Comment" clipPath="url(#clip0_5565_6276)">
                <path
                    id="Vector"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.9995 34.4994L37.9995 34.499V10.499L9.99951 10.4994V40.499L19.9995 34.4994ZM31.999 20.5H15.999V16.5H31.999V20.5ZM24.999 28.5H15.999V24.5H24.999V28.5Z"
                    fill="#101214"
                />
            </g>
            <defs>
                <clipPath id="clip0_5565_6276">
                    <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(-0.000976562 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
